import { render, staticRenderFns } from "./SubscribeOutOfStock.vue?vue&type=template&id=aa5aa080&"
import script from "./SubscribeOutOfStock.vue?vue&type=script&lang=js&"
export * from "./SubscribeOutOfStock.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeOutOfStock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusButton: require('/~/src/modules/opus/components/Form/Button.vue').default,OpusRenderInput: require('/~/src/modules/opus/components/Form/RenderInput.vue').default})
